import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Profile.module.css';
import ProfileForm from 'components/profileForm/costumerProfileForm';
import { IoCloseOutline } from "react-icons/io5";
import { FaArrowAltCircleRight } from 'react-icons/fa';
import { logout } from 'services/userLogin/logout';
import { checkSession } from 'services/userLogin/check-session';
import { getProfileInfo } from 'services/profileManegement/get-profile-info';

export default function CompleteProfile() {
    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState({
        first_name: "",
        last_name: "",
        country: "",
        phone: "",
        zip: "",
        city: "",
        street: "",
        status: "",
        faculty: "",
        account_holder: "",
        iban: "",
        bic: "",
        emergencyContacts: [{ name: '', phone: '' }],
    });

    const verifySession = async () => {
        try {
            const sessionData = await checkSession();
            if (sessionData.session_active) {
                const { is_customer, is_employee, is_profile_completed, is_password_completed, has_kid, is_statistic } = sessionData.user_data;
                if (!is_customer) {
                    if (is_employee) {
                        if (is_password_completed) {
                            if (is_statistic) {
                                navigate('/reservierungsportal/StatisticPage', { replace: true });

                            } else {
                                navigate('/reservierungsportal/EmployHomePage', { replace: true });
                            }
                        } else {
                            navigate('/reservierungsportal/EmploySetPassword', { replace: true });

                        }
                    } else {
                        navigate('/reservierungsportal', { replace: true });
                    }
                } else {
                    if (is_profile_completed) {
                        if (has_kid) {
                            navigate("/reservierungsportal/CustomerHomePage", { replace: true });
                        }
                    } else {
                        try {
                            const profileData = await getProfileInfo();
                            if (profileData) {
                                const profile = profileData.profile;
                                if (profileData.success) {
                                    setInitialValues(profile);
                                }
                            }
                        } catch (error) {
                            console.error("Fehler beim Laden von Daten:", error);
                        }
                    }
                }
            } else {
                navigate('/reservierungsportal', { replace: true });
            }
        } catch (error) {
            console.error("Fehler bei der Sitzungsprüfung:", error);
        }
    };

    useEffect(() => {
        verifySession();
    }, []);
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div>
                    <a className={styles.closeButton} onClick={logout} href='/reservierungsportal'>
                        <IoCloseOutline />
                    </a>
                    <h2>Profil vervollständigen</h2>
                    <p>
                        Um Deine Registrierung erfolgreich abzuschließen benötigen wir noch folgende Informationen.
                    </p>
                </div>
            </div>

            <ProfileForm
                initialValues={initialValues}
                buttonOptions={[
                    {
                        label: "Zurück",
                        onClick: () => {
                            logout();
                            navigate(-1);
                        },
                    },
                    {
                        label: "Speichern & Weiter",
                        icon: <FaArrowAltCircleRight />,
                    },
                ]}
                onSubmitSuccess={() => {
                    navigate('/reservierungsportal/NewkidsProfile');
                }}
            />

        </div>
    );
}
